import { TV2M_API_BASE_PATH } from '@apm/contracts';
import type { AdCreativeResponse } from '@apm/contracts';

/**
 * 광고 소재 단건 조회 (`docs/13` §3.2 — B11 이 tv2m-server 에 만든 공개 엔드포인트).
 *
 * **`product.ts` 의 대칭이다.** 저쪽은 BLOOM Server 의 상품을, 이쪽은 TV2M 의 광고 소재를 읽는다 —
 * 광고 상품은 BLOOM 카탈로그에 없기 때문이고(`docs/12` §2.3), 그 하나가 두 모드를 남기는
 * 이유의 절반이다.
 *
 * **서버 주소를 인자로 받는다.** TV2M 주소는 빌드 시점이 아니라 `GET /v1/bloom/config` 로
 * 오므로(`docs/12` §2.4) `config.ts` 에서 읽을 수 없다 — `product.ts` 가 `config.serverUrl`
 * 을 직접 읽는 것과 갈리는 지점이고, 그쪽은 부트스트랩 값이라 그럴 수 있다.
 *
 * **인증을 싣지 않는다.** 이 엔드포인트는 공개다 — 여기 있는 것은 TV 화면에 이미 떠
 * 있던 광고의 제목과 가격이다. `X-TV2M-Api-Key` 는 실을 수도 있지만(번들에 있다) 그러면
 * 키가 필요한 경로처럼 보이고, 실제로 필요해졌을 때 이 함수가 그것을 말해 주지 않는다.
 *
 * **실패를 던지지 않고 `null` 로 돌려준다** (`product.ts` 와 같은 방침). 소재를 못 읽어도
 * 화면은 자기가 아는 것(캠페인 id·유입 경로)을 그려야 한다.
 */
export async function fetchAdCreative(
  tv2mServerUrl: string,
  campaignId: string,
  signal?: AbortSignal,
): Promise<AdCreativeResponse | null> {
  const base = tv2mServerUrl.replace(/\/+$/, '');
  const url = `${base}${TV2M_API_BASE_PATH}/creatives/${encodeURIComponent(campaignId)}`;
  try {
    const options = signal ? { signal } : {};
    const response = await fetch(url, options);
    if (!response.ok) return null;
    return (await response.json()) as AdCreativeResponse;
  } catch {
    return null;
  }
}
